import axios from "axios";
import React, { useEffect, useState } from "react";
import { UseHrApp } from "../../utils/context";
import EditPassword from "../../components/EditPassWordModal";
import { CircularProgress } from "@mui/material";
import { MdOutlineTroubleshoot } from "react-icons/md";

export default function EmMain() {
  function getTimeOfDay() {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      return "Morning";
    } else if (currentHour >= 12 && currentHour < 18) {
      return "Afternoon";
    } else {
      return "Evening";
    }
  }

  const timeOfDay = getTimeOfDay();

  const { Emtoken } = UseHrApp();

  const [employeeData, setEmployeeData] = useState({});
  const [loading , setloading] = useState(MdOutlineTroubleshoot);

  async function GetSingleEmployeeData() {
    try {
      const res = await axios({
        url: "https://hr-app-api.onrender.com/employees/employee",
        method: "GET",
        headers: {
          Authorization: `Bearer ${Emtoken}`,
        },
      });
      if (res?.data?.status) {
        setEmployeeData(res?.data?.data);
        setloading(false);
      }
    } catch (error) {
      console.log("error");
    }
  }

  console.log(employeeData);
  useEffect(() => {
    GetSingleEmployeeData();
  }, []);

  return (
    <div className=" min-w-screen min-h-[91vh] bg-[#f4f8fd] font-[Archivo]">
      <div className="p-3 lg:pl-[17em] lg:pr-[2em] w-full pt-[1em] ">

        <div className="mb-6 my-[3em]">
          <p className="text-[#494949]">
            Hello , {employeeData.firstname} {employeeData.lastname}
          </p>
          <p className="text-3xl font-bold">Good {timeOfDay}</p>
        </div>
        {loading? 
       (<div className="w-full min-h-[50vh] flex justify-center items-center">
         <CircularProgress/>
        </div>
        )
        :(
          <>
        <div className="grid md:grid-cols-2 md:grid-rows-6 lg:grid-cols-3 lg:grid-rows-2 gap-5">
          <div>
            <label htmlFor="firstname">Firstname</label>
            <p className="min-w-[80px] p-4 bord  text-black">
              {employeeData.firstname}
            </p>
          </div>
          <div>
            <label htmlFor="lastname">lastname</label>
            <p className="min-w-[80px] p-4 bord">{employeeData.lastname}</p>
          </div>

          <div>
            <label htmlFor="email">Email</label>

            <p className="min-w-[80px] p-4 bord">{employeeData.email}</p>
          </div>

          <div>
            <label htmlFor="firstname">Contact</label>
            <p className="min-w-[80px] p-4 bord">{employeeData.contact}</p>
          </div>

          <div>
            <label htmlFor="firstname">Status</label>
            <p className="min-w-[80px] p-4 bord">{employeeData.status}</p>
          </div>
          {employeeData.department ? (
            <div>
              <label htmlFor="firstname">Department</label>
              <p className="min-w-[80px] p-4 bord">
                {employeeData.department.name}
              </p>
            </div>
          ) : null}

          <div>
            <label htmlFor="salary">Salary</label>
            <p className="min-w-[80px] p-4 bord">{employeeData.salary}</p>
          </div>

          <div>
            <label htmlFor="role">Role</label>
            <p className="min-w-[80px] p-4 bord">{employeeData.role}</p>
          </div>

          <div>
            <label htmlFor="gender">Gender</label>
            <p className="min-w-[80px] p-4 bord">{employeeData.gender}</p>
          </div>

          <div>
            <label htmlFor="Leave Days Left">Leave Days Left</label>
            <p className="min-w-[80px] p-4 bord">
              {employeeData.leaveDaysRemaining}
            </p>
          </div>
        </div>

<EditPassword/>
</>
)}
       
      </div>
    </div>
  );
}
